// @ts-nocheck
import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { Alert } from 'loyal-react'
import twoFactorAuthentication from '../Checkout/actions'
import InputRange from './InputRange'
import { StixWrapper, StixHeader, StixInfos, SideBar, StixStars } from './'
import PropTypes from 'prop-types'
import { actions as mileageActions } from '../Services/Mileage'
import { filterPartnerMileage } from '../Services/Mileage/actions'
import * as actions from './actions'
import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'

class Stix extends Component {
  constructor (props) {
    super(props)

    this.state = {
      step: this.props.stix.supplierId ? 2 : 1,
      loadingPayment: false,
      totalPoints: 1,
      error: false,
      partnerName: '',
      paymentSelected: 'POINTS_ONLY',
      multipliceRule: 0,
      configurationRule: false,
      Partners: this.props.partners,
      isModalConfirmationOpened: false
    }

    this.HandlerValueSelected = this.HandlerValueSelected.bind(this)
    this.disabledVerify = this.disabledVerify.bind(this)
  }

  showError () {
    return this.props.errorRedemption && this.props.errorRedemption !== '' ? (
      <Fragment>
        {this.closeModal()}

        <Alert
          isError
          title={'Não foi possível concluir a sua transferência.'}
          description='Erro ao tentar efetuar o resgate'
          className='pb-2'
          onClose={() => this.props.closeErrorMileage()}
        />
      </Fragment>
    ) : (
      ''
    )
  }

  showStixError () {
    return this.props.stix && this.props.stix.error && this.props.stix.error.response ? (
      <Fragment>
        {this.closeModal()}

        <Alert
          isError
          title={this.props.stix.error.response.data}
          description=''
          className='pb-2'
          onClose={() => this.props.closeErrorStix()}
        />
      </Fragment>
    ) : (
      ''
    )
  }

  MessageBalanceLimit () {
    return this.ValidationBalanceLimit() ? (
      <Fragment>
        {this.closeModal()}

        <Alert
          isError
          title={'Não podemos prosseguir com a operação!'}
          description='Seu saldo é insulficiente para a transferência.'
          className='pb-2'
        />
      </Fragment>
    ) : (
      ''
    )
  }

  ValidationBalanceLimit () {
    return parseInt(this.state.totalPoints) > parseInt(this.props.pointsValue)
  }

  selectPartner () {
    let partner = this.props.partners[0]

    this.props.pointsToMiles(partner.vendorId, '')

    this.props.toggleSupplierId(partner.vendorId)

    this.setState({
      partnerName: partner.name,
      totalPoints: ''
    })
  }

  nextStep (step) {
    this.setState({ step: step })
  }

  HandlerValueSelected (value) {
    this.setState({
      totalPoints: value
    })
    this.props.pointsToMiles(this.props.stix.supplierId, value)
  }

  getOrderRequest = () => ({
    totalMiles: this.state.totalPoints,
    totalPoints: this.state.totalPoints,
    catalogId: this.props.catalog.id,
    transferKey: 'cpf',
    loyaltyNumber: this.props.participant.cpf.value,
    cpf: this.props.participant.cpf.value,
    participantName: this.props.participant.name.value,
    offline: false,
    orderItems: [
      {
        quantity: 1,
        points: this.state.totalPoints,
        miles: this.state.totalPoints,
        totalPoints: this.state.totalPoints,
        packageName: this.createStringValueResult()
      }
    ],
    orderTypeId: 1
  });

  createStringValueResult = () => {
    let res = parseInt(this.props.calculator.miles)
    res += res === 1 ? ' ponto ' : ' pontos '
    res += 'stix'
    return res
  }

  closeModal = () => {
    if (this.state.isModalConfirmationOpened) {
      this.setState({
        isModalConfirmationOpened: false
      })
    }
  }
  handlePaymentConfirmation = () => {
    this.setState({
      isModalConfirmationOpened: true
    })
  }

  formatTitle = title => {
    return title.split(' ')[0]
  }

  handlerFinalizePayment = () => {
    this.props.mileageRedemption(
      this.getOrderRequest(),
      this.props.stix.supplierId
    )
  }

  disableConfigurationRule (value) {
    this.setState({
      configurationRule: value
    })
  }

  getConfigurationByKey = key =>
    this.props.configuration[this.props.stix.supplierId].filter(
      x => x.key === key
    )

  updateMaximumRedemptionLimit () {
    if (
      this.props.stix.minimumRedemptionLimit === 0 ||
      this.props.pointsValue === 0
    ) {
      return
    }

    this.props.changeMaximumRedemptionLimit(
      ~~(this.props.pointsValue / this.props.stix.minimumRedemptionLimit) *
        this.props.stix.minimumRedemptionLimit
    )
  }

  // #region [Life clycle]

  componentDidUpdate (prevProps) {
    if (prevProps.enableConfiguration !== this.props.enableConfiguration) {
      this.disableConfigurationRule(this.props.enableConfiguration)
    }

    if (prevProps.configuration !== this.props.configuration) {
      const minimumRedemptionLimit = this.getConfigurationByKey(
        'MinimumRedemptionLimit'
      )
      const multiplicityRule = this.getConfigurationByKey('MultiplicityRule')

      if (multiplicityRule === undefined) { return }

      if (minimumRedemptionLimit === undefined) { return }

      const minimumLimit = parseInt(minimumRedemptionLimit[0].value)

      this.props.changeMinimumRedemptionLimit(minimumLimit)

      if (this.props.stix.redemptionPoints < minimumLimit) {
        this.props.changeRedemptionPoints(minimumRedemptionLimit)
      }
    }

    if (
      prevProps.pointsValue !== this.props.pointsValue ||
      prevProps.stix.minimumRedemptionLimit !==
        this.props.stix.minimumRedemptionLimit
    ) {
      this.updateMaximumRedemptionLimit()
    }

    if (
      prevProps.partners && this.props.partners &&
      prevProps.partners.length === 0 && this.props.partners.length > 0 &&
      prevProps.partners !== this.props.partners) {
      this.selectPartner()
    }

    if (
      this.props.sendTwoFactorAuthorization &&
      this.props.sendTwoFactorAuthorization.enable &&
      prevProps.sendTwoFactorAuthorization.enable !== this.props.sendTwoFactorAuthorization.enable
    ) {
      this.closeModal()
    }
    this.MessageBalanceLimit()
  }

  // #endregion

  disabledVerify () {
    return this.props.stix.error || this.props.calculator.miles === 0 || this.ValidationBalanceLimit()
  }

  render () {
    return (
      <StixWrapper>
        {this.showError}
        {this.showStixError}
        {this.MessageBalanceLimit}
        <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
          <div className='row mx-0'>
            <div className='modalConfirmationVoucher'>
              <SecondFactorAuthentication
                show={this.props.sendTwoFactorAuthorization && this.props.sendTwoFactorAuthorization.enable}
                secondFactorAuthConfirmated={
                  this.props.sendTwoFactorAuthorization && this.props.sendTwoFactorAuthorization
                    .secondFactorAuthConfirmated
                }
                sendTwoFactorAuthorization={this.props.sendTwoFactorAuthorization && this.props.sendTwoFactorAuthorization}
                authorizeWithTokenMileage={this.props.authorizeWithTokenMileage}
                authorizeWithTokenResend={this.props.authorizeWithTokenResend}
                authorizeWithTokenLastTry={this.props.authorizeWithTokenLastTry}
                vendorId={Number(this.props.stix.supplierId)}
                errorToken={this.props.sendTwoFactorAuthorization && this.props.sendTwoFactorAuthorization.errorToken}
                paymentSelected={this.state.paymentSelected}
                isCreatingPurchase={this.props.mileageIsLoading}
                oidc={this.props.oidc}
              />
            </div>
            <div className='col-12 radius border border-color-ui-3'>
              <StixHeader>envie pontos para parceiros</StixHeader>
              <div className='stix-content row radius-bottom bg-white px-1 py-3'>
                <div
                  id='step-2'
                  className='Step2 step-2 col-12 px-2'
                >
                  <div className='row mx-0'>
                    <div className='col-12 px-0'>
                      <div className='row mx-0 mb-3'>
                        <div className='col-12 px-0'>
                          <p className='txt-body pb-half'>Quantos pontos deseja transferir?</p>
                        </div>
                        <div className='col-12 px-0'>
                          <div className='row align-items-center'>
                            <div className='box-quantity col-12 col-md-3'>
                              <InputRange
                                minimunValue={
                                  this.props.stix.minimumRedemptionLimit
                                }
                                maximunValue={
                                  this.props.stix.maximumRedemptionLimit
                                }
                                multipliceRule={this.state.multipliceRule}
                                step={
                                  this.props.stix.minimumRedemptionLimit
                                }
                                handlerValueSelected={
                                  this.HandlerValueSelected
                                }
                                isDivisible
                                pointsName={this.props.catalog.currencyConfiguration.pointsName}
                              />
                            </div>
                            <div className='col-12 col-md-auto txt-center my-2 my-md-0'>
                              <span className='icon-equal'>=</span>
                              <span className='equal-line d-md-none d-block' />
                            </div>
                            <div className='col-12 col-md my-2 my-md-0'>
                              <div className='row'>
                                <div className='col-12'>
                                  <p>Você vai receber na Stix:</p>
                                </div>
                                <div className='col-12 pt-half'>
                                  <p className='txt-title-1'>
                                    <p className='color-featured txt-title-2'>
                                      <StixStars totalStars={this.props.calculator.miles} />
                                    </p>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row mx-0'>
                        <div className='col-12 px-0'>
                          <p className='txt-body pb-half'>Onde você pode usar seus pontos stix:</p>
                        </div>
                        <div className='col-12 px-0 pt-1'>
                          <div className='row px-1 align-items-center'>
                            <div className='col-12 col-md border border-ui-3 px-3 py-2 box-benefits-stix'>
                              <div className='bg-logo-stix' />
                              <div className='bg-logo pao-de-acucar' />
                              <div className='bg-logo drogaraia' />
                              <div className='bg-logo extra' />
                              <div className='bg-logo drogasil' />
                              <div className='bg-logo mais-parceiros' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id='step-3'
                  className='Step3 step-3 col-12 bg-white pt-0 pt-md-3'
                >
                  <StixInfos />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-4'>
          <div className='row'>
            <SideBar
              loadingPayment={this.props.mileageIsLoading}
              disabledButton={this.disabledVerify}
              partnerName={this.state.partnerName}
              creditValue={this.state.totalPoints}
              starValue={this.props.calculator.miles}
              handlerFinalizePayment={this.handlerFinalizePayment}
              handlePaymentConfirmation={this.handlePaymentConfirmation}
              closeModal={this.closeModal}
              isModalConfirmationOpened={this.state.isModalConfirmationOpened}
              pointsName={this.props.catalog.currencyConfiguration.pointsName}
              formatTitle={this.formatTitle}
              isLoading={this.props.stix.isLoading}
            />
          </div>
        </div>
      </StixWrapper>
    )
  }
}

const mapStateToProps = ({ mileage, stix, balance, catalog, participant, oidc }) => ({
  mileageIsLoading: mileage.isLoading,
  errorRedemption: mileage.errorRedemption,
  configuration: stix.configuration,
  stix: stix,
  balanceIsLoading: balance.isLoading,
  pointsValue: balance.pointsValue,
  catalog: catalog,
  participant: participant,
  sendTwoFactorAuthorization: mileage.sendTwoFactorAuthorization,
  enableConfiguration: stix.enableConfiguration,
  partners: filterPartnerMileage(stix.partners, false),
  oidc,
  calculator: stix.calculator
})

const mapDispatchToProps = dispatch => ({
  toggleSupplierId: supplierId =>
    dispatch(actions.toggleSupplierId(supplierId)),
  pointsToMiles: (supplierId, points) =>
    dispatch(actions.convertPointsToMiles(supplierId, points)),
  changeRedemptionPoints: pointsAmout =>
    dispatch(actions.changeRedemptionPoints(pointsAmout)),
  changeMinimumRedemptionLimit: minimumRedemptionLimit =>
    dispatch(actions.changeMinimumRedemptionLimit(minimumRedemptionLimit)),
  changeMaximumRedemptionLimit: maximumRedemptionLimit =>
    dispatch(actions.changeMaximumRedemptionLimit(maximumRedemptionLimit)),
  mileageRedemption: (order, supplierId) =>
    dispatch(mileageActions.mileageRedemption(order, supplierId)),
  closeErrorMileage: () => dispatch(mileageActions.closeErrorMileage()),
  closeErrorStix: () => dispatch(actions.closeErrorStix()),
  authorizeWithTokenMileage: (orderId, Token, orderIdMileage, vendorId) =>
    dispatch(
      mileageActions.authorizeWithTokenMileage(
        orderId,
        Token,
        orderIdMileage,
        vendorId
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    )
})

// Objeto que retorna da ação: convertPointsToMiles.
const calculatorMessage = PropTypes.shape({
  points: PropTypes.string,
  miles: PropTypes.string
})

// Propriedades do componente Mileage.
Stix.propTypes = {
  stix: PropTypes.object,
  mileageIsLoading: PropTypes.bool,
  calculator: PropTypes.arrayOf(calculatorMessage),
  pointsValue: PropTypes.number,
  supplierId: PropTypes.number,
  configuration: PropTypes.object,
  participant: PropTypes.object,
  catalog: PropTypes.object,
  partners: PropTypes.object,
  toggleSupplierId: PropTypes.func,
  changeRedemptionPoints: PropTypes.func,
  changeMinimumRedemptionLimit: PropTypes.func,
  changeMaximumRedemptionLimit: PropTypes.func,
  mileageRedemption: PropTypes.func,
  errorRedemption: PropTypes.string,
  sendTwoFactorAuthorization: PropTypes.object,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  closeErrorMileage: PropTypes.func,
  closeErrorStix: PropTypes.func,
  enableConfiguration: PropTypes.bool,
  oidc: PropTypes.bool,
  pointsToMiles: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Stix)



// WEBPACK FOOTER //
// ./src/features/Stix/Stix.js